var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-chat-component" }, [
    _c("div", { staticClass: "room-chat" }, [
      _c("div", { staticClass: "room-chat-header" }, [
        _c("div", { staticClass: "room-chat-setting" }, [
          _c("div", { staticClass: "room-chat-setting-start" }, [
            _c(
              "button",
              {
                staticClass: "room-chat-setting-button change",
                on: { click: _vm.changeMyNickname },
              },
              [_vm._v(_vm._s(_vm.$t("chat.changeNickname")))]
            ),
          ]),
          _c(
            "div",
            { staticClass: "room-chat-setting-end" },
            [
              _c(
                "button",
                {
                  staticClass: "room-chat-setting-button setting",
                  on: { click: _vm.onToggleChatSetting },
                },
                [_vm._v(_vm._s(_vm.$t("common.setting")))]
              ),
              _c("GrmMenu", {
                staticClass: "chatSetting",
                attrs: {
                  "text-align": "left",
                  open: _vm.isOpenChatSetting,
                  list: _vm.chatSettingList,
                },
                on: {
                  "update:open": function ($event) {
                    _vm.isOpenChatSetting = $event
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        {
          staticClass: "room-chat-drag-wrapper",
          on: {
            dragenter: [
              function ($event) {
                $event.stopPropagation()
                return _vm.showDragFile.apply(null, arguments)
              },
              function ($event) {
                $event.preventDefault()
              },
            ],
            dragleave: [
              function ($event) {
                $event.stopPropagation()
                return _vm.hideDragFile.apply(null, arguments)
              },
              function ($event) {
                $event.preventDefault()
              },
            ],
            drop: [
              _vm.dropFile,
              function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
              },
            ],
            dragover: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeDragFile,
                  expression: "activeDragFile",
                },
              ],
              staticClass: "chat-drag-file",
            },
            [
              _c("div", { staticClass: "chat-drag-file-icon" }),
              _c("p", { staticClass: "chat-drag-file-tx" }, [
                _vm._v(" " + _vm._s(_vm.$t("chat.file.drag")) + " "),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "room-chat-body", style: _vm.dragStyle },
            [
              _vm.fixedNotice
                ? _c("RoomNotice", {
                    attrs: { notice: _vm.fixedNotice, section: "chat" },
                    on: {
                      onChangeNoticeSection: function ($event) {
                        return _vm.$emit("onChangeSection", "notice")
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                { ref: "scroll", staticClass: "overflow-y-auto h-full" },
                [
                  _c(
                    "div",
                    { staticClass: "room-chat-message-list" },
                    [
                      _c("div", {
                        ref: "chatScroll",
                        staticClass: "chat-scroll",
                      }),
                      _c("RoomMyChat"),
                      _vm.uploadRoomFileList
                        ? _c("RoomFile", {
                            attrs: {
                              files: _vm.uploadRoomFileList,
                              section: "chat",
                              isUploading: "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm.isUseChat
            ? _c(
                "div",
                { staticClass: "room-chat-footer", style: _vm.dragStyle },
                [
                  _c("div", { staticClass: "room-chat-send" }, [
                    _c("div", { staticClass: "room-chat-send-header" }, [
                      _c(
                        "div",
                        {
                          staticClass: "room-chat-send-whisper",
                          class: { isOpen: _vm.isOpenWhisperList },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "room-chat-send-whisper-header" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "room-chat-send-whisper-input-wrapper",
                                },
                                [
                                  _c("input", {
                                    ref: "whisperSearchText",
                                    staticClass: "room-chat-send-whisper-input",
                                    attrs: {
                                      type: "text",
                                      placeholder: _vm.$t(
                                        "chat.whisper.placeholder"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.searchRoomUser(
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "room-chat-send-whisper-body" },
                            [
                              _c(
                                "ul",
                                { staticClass: "room-chat-send-whisper-list" },
                                _vm._l(_vm.whisperList, function (user) {
                                  return _c(
                                    "li",
                                    {
                                      key: user.userId,
                                      staticClass:
                                        "room-chat-send-whisper-item",
                                    },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "room-chat-send-whisper-button",
                                          on: {
                                            click: function ($event) {
                                              return _vm.selectWhisper(user)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "room-chat-send-whisper-user-nickname",
                                              class: {
                                                selected:
                                                  user.userId ===
                                                  _vm.whisperTarget,
                                              },
                                            },
                                            [_vm._v(_vm._s(user.nickname))]
                                          ),
                                          user.roomUserRole.roleId !==
                                          "participant"
                                            ? _c(
                                                "GrmMark",
                                                {
                                                  staticClass: "ml-1 grm-mark",
                                                  attrs: {
                                                    "data-user-role":
                                                      user.roomUserRole.roleId,
                                                    "data-opener": _vm.isOpener(
                                                      user.userId
                                                    ),
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.displayRoleName(
                                                        user.roomUserRole.roleId
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "room-chat-send-options" }, [
                        _c(
                          "div",
                          { staticClass: "room-chat-send-option whisper" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "room-chat-send-option-button whisper",
                                on: { click: _vm.onToggleWhisperType },
                              },
                              [_vm._v(_vm._s(_vm.whisperTypeText))]
                            ),
                            _vm.whisperTarget
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "room-chat-send-option-whisper",
                                    on: { click: _vm.toggleWhisperList },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getUserNickname(_vm.whisperTarget)
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("GrmMenu", {
                              staticClass: "whisperType",
                              attrs: {
                                "text-align": "left",
                                open: _vm.isOpenWhisperType,
                                list: _vm.whisperTypeList,
                              },
                              on: {
                                "update:open": function ($event) {
                                  _vm.isOpenWhisperType = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "room-chat-send-option file" },
                          [
                            _vm.hasEmceeRole() ||
                            (_vm.isParticipantRole() &&
                              _vm.useParticipantFileUpload)
                              ? _c("button", {
                                  staticClass:
                                    "room-chat-send-option-button file",
                                  on: { click: _vm.handleClickUploadFile },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "room-chat-send-body" }, [
                      _c(
                        "div",
                        { staticClass: "room-chat-send-textarea-wrapper" },
                        [
                          _c("textarea", {
                            ref: "inputText",
                            staticClass: "room-chat-send-textarea",
                            attrs: { placeholder: _vm.$t("chat.placeholder") },
                            on: {
                              keypress: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                )
                                  return null
                                return _vm.onEnter.apply(null, arguments)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]),
                ]
              )
            : _c("div", { staticClass: "room-chat-send-footer" }, [
                _c("div", { staticClass: "chat-input-disable" }, [
                  _vm._v(_vm._s(_vm.$t("chat.disabled"))),
                ]),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }